export const commonErrorMessage = "Đã có lỗi xảy ra, xin vui lòng thử lại sau.";
